import { gql } from '@apollo/client'

export const FREE_BUNDLE_SCHEDULE = gql`
  mutation FreeBundleSchedule($id: ID!) {
    freeBundleSchedule(input: { id: $id }) {
      bundleSchedule {
        id
        status
        audience
        startDate
        endDate
        consumedAt
        freedAt
        campaign {
          id
          name
        }
      }
      errors
    }
  }
`
